import { useEffect } from "react";
import { useBooleanFlag } from "@apac/feature-flags";
import { useDeviceType } from "@b2bportal/core-utilities";
import { PATH_MAINTENANCE } from "@hopper-b2b/utilities";
import { FeatureFlagNames, COMING_SOON_PATH } from "@hsbc/utilities";

/**
 * This hook is used to redirect the user to the maintenance page or the coming soon page
 * based on the feature flag & device type.
 */
export const useUnavailableRedirect = () => {
  const { isMobile, isTablet, isDesktop, isDetectingDeviceType } =
    useDeviceType();

  const maintenanceEnabled =
    useBooleanFlag(FeatureFlagNames.MAINTENANCE) ?? false;
  const isComingSoonEnabled =
    useBooleanFlag(FeatureFlagNames.DESKTOP_COMING_SOON) ?? false;

  useEffect(() => {
    if (maintenanceEnabled) {
      window.location.pathname = PATH_MAINTENANCE;
    }
  }, [maintenanceEnabled]);

  useEffect(() => {
    if (
      !(isMobile || isTablet || isDesktop) &&
      !isDetectingDeviceType &&
      isComingSoonEnabled
    ) {
      window.location.pathname = COMING_SOON_PATH;
    }
  }, [
    isComingSoonEnabled,
    isDesktop,
    isDetectingDeviceType,
    isMobile,
    isTablet,
  ]);
};
